module.exports = __webpack_public_path__ + "img/drumKitHeader.f9c2da1c.png";